// const logo = new Image().src = 'https://s3.amazonaws.com/isistudio-public/dlz2/images/themes/renaissance-hotels/logo.png';
// const heroImageLarge = new Image().src = 'https://s3.amazonaws.com/isistudio-public/dlz2/images/themes/renaissance-hotels/heroLarge.png';
// const heroImageSmall = new Image().src = 'https://s3.amazonaws.com/isistudio-public/dlz2/images/themes/renaissance-hotels/heroSmall.png';
// const heroImageXSmall = new Image().src = 'https://s3.amazonaws.com/isistudio-public/dlz2/images/themes/renaissance-hotels/heroXSmall.png';
// const exploreImageLarge = new Image().src = 'https://s3.amazonaws.com/isistudio-public/dlz2/images/themes/renaissance-hotels/exploreLarge.png';
// const exploreImageSmall = new Image().src = 'https://s3.amazonaws.com/isistudio-public/dlz2/images/themes/renaissance-hotels/exploreSmall.png';
// const exploreImageXSmall = new Image().src = 'https://s3.amazonaws.com/isistudio-public/dlz2/images/themes/renaissance-hotels/exploreXSmall.png';
import { themePrimaryColorsBrand } from '../style-constants';

export default {
  extendedTheme: () => ({
    logo: (new Image().src =
      'https://s3.amazonaws.com/isistudio-public/dlz2/images/themes/renaissance-hotels/logo.png'),
    logoStyle: { width: 165, height: 'inherit', maxHeight: 'inherit' },
    heroImageLarge: (new Image().src =
      'https://s3.amazonaws.com/isistudio-public/dlz2/images/themes/renaissance-hotels/heroLarge.png'),
    exploreImageLarge: (new Image().src =
      'https://s3.amazonaws.com/isistudio-public/dlz2/images/themes/renaissance-hotels/exploreLarge.png'),
    palette: {
      primary: {
        main: themePrimaryColorsBrand.RHR,
      },
      secondary: {
        main: '#1c1c1c',
      },
      primaryBtnHover: {
        main: '#0f3c52',
      },
      buttonText: {
        main: '#ffffff',
      },
      interaction: {
        main: '#00769e',
      },
      text: {
        primary: '#1c1c1c',
      },
      link: {
        primary: '#1c1c1c',
      },
    },
    typography: {
      useNextVariants: true,
      fontFamily: [
        '"ProximaNova-Regular"',
        '"Roboto"',
        '"Helvetica"',
        '"Arial"',
        'sans-serif',
      ].join(','),
    },
  }),
  typography: (theme, remCalc) => {
    return {
      h1: {
        fontFamily: 'GalaxiePolaris-Bold',
        color: '#1c1c1c',
        [theme.breakpoints.up('sm')]: {
          fontSize: remCalc(54),
          lineHeight: remCalc(60),
        },
        [theme.breakpoints.down('xs')]: {
          fontSize: remCalc(34),
          lineHeight: 1.24,
        },
      },
      h2: {
        fontFamily: 'GalaxiePolaris-Bold',
        color: '#1c1c1c',
        [theme.breakpoints.up('sm')]: {
          fontSize: remCalc(40),
          lineHeight: 1.15,
        },
        [theme.breakpoints.down('xs')]: {
          fontSize: remCalc(30),
          lineHeight: 1.2,
        },
      },
    };
  },
  extraTypography: (theme, remCalc) => {
    return {
      hero: {
        fontFamily: 'GalaxiePolaris-Bold',
        color: '#1c1c1c',
        [theme.breakpoints.up('sm')]: {
          fontSize: remCalc(44),
          lineHeight: 1.09,
        },
        [theme.breakpoints.down('xs')]: {
          fontSize: remCalc(44),
          lineHeight: 1.09,
        },
      },
      card: {
        fontFamily: 'GalaxiePolaris-Bold',
        fontWeight: 'bold',
        color: '#1c1c1c',
        [theme.breakpoints.up('sm')]: {
          fontSize: remCalc(38),
          lineHeight: 1.16,
        },
        [theme.breakpoints.down('xs')]: {
          fontSize: remCalc(28),
          lineHeight: 1.21,
        },
      },
    };
  },
};
